export const getCleverRedirectUri = () => {
  const explicit = process.env.REACT_APP_CLEVER_REDIRECT_URI;
  if (explicit) return explicit;
  if (typeof window === "undefined") return "";
  // if localhost add test to the end
  if (window.location.hostname === "localhost") {
    return `${window.location.origin}/test`;
  }
  return `${window.location.origin}/`;
};
